import { $_DKD, $_GCD, $_CD } from '@/confs/common.const.js';
import commonApi from "@/apis/common.api.js";
import gripUtil from "@/libs/grip.util";

/* 방역 */
export default {
    state: {
        //모기방역
        mosquitoList: [],
        mosquitoHjdMap: {},

        //매개모기
        mediumMosqList: [],
        selectedSubMenu: '',

        selectedMeMosq: {},
        mosqAct: '',
        totalMeMosVal: '',

    },
    getters: {
        getMosquitoList(state) {
            return state.mosquitoList;
        },
        getMosquitoHjdMap(state) {
            return state.mosquitoHjdMap;
        },
        getMediumMosqList(state) {
            return state.mediumMosqList;
        },
        getSelectedSubMenu(state) {
            return state.selectedSubMenu;
        },
        getSelectedMeMosq(state) {
            return state.selectedMeMosq;
        },
        getMosqAct: function(state) {
            return state.mosqAct;
        },
        getTotalMeMosVal: function(state) {
            return state.totalMeMosVal;
        },
        
    },
    mutations: {
        MOSQUITO_LIST(state, mosquitoList) {
            state.mosquitoList = mosquitoList;
        },
        MOSQUITO_HJD_MAP(state, mosquitoHjdMap) {
            state.mosquitoHjdMap = mosquitoHjdMap;
        },
        
        MEDIUM_MOSQ_LIST(state, mediumMosqList) {
            state.mediumMosqList = mediumMosqList;
        },
        SELECTED_SUB_MENU(state, selectedSubMenu) {
            state.selectedSubMenu = selectedSubMenu;
        },
        SELECTED_ME_MOSQ(state, selectedMeMosq) {
            state.selectedMeMosq = selectedMeMosq;
        },
        MOSQ_ACT: function(state, mosqAct) {
            state.mosqAct = mosqAct;
        },
        TOTAL_ME_MOS_VAL: function(state, totalMeMosVal) {
            state.totalMeMosVal = totalMeMosVal;
        },
    },
    actions: {
        FETCH_MOSQUITO_LIST({commit}) {
            let moquitoMap = {};

            return commonApi.fetchRepoDataListWithCodeName($_DKD.MOSQUITO)
                .then((res)=> {
                    let list = res.data.data;
                    if(typeof list !== 'undefined' && list.length > 0) {

                        list = list.filter(function(data) {
                            return typeof data.val2 !== 'undefined'
                        }.bind(this));
                        let hjdMap = gripUtil.toMap(list, 'valNm2');
                        let maxLeng = list.length;

                        for(let key in hjdMap ) {
                            let hjdData = hjdMap[key];
                            let hjdCnt = hjdData.length;

                            if(typeof moquitoMap[key] === 'undefined') {
                                moquitoMap[key] = {};
                                moquitoMap[key].hjd = key;
                                moquitoMap[key].cnt = hjdCnt;
                                moquitoMap[key].total = maxLeng;
                            }
                        }
                    }
                    commit('MOSQUITO_HJD_MAP', moquitoMap);
                    commit('MOSQUITO_LIST', list);
                })
        },
        
        FETCH_MEDIUM_MOSQ_LIST({commit}) {
            let q = 'searchMaxBaseColumn=basdtVal&searchMaxBaseColumn=val11';
            return commonApi.fetchRepoDataList($_DKD.MEDIUM_MOSQ, q)
            .then(function(res) {
                let list = res.data.data;
                let totalMosqAct = 0;
                let totalMeMosVal = 0;
                list.forEach(function(d) {
                    if(typeof d.val10 === 'undefined') {
                        d.val10 = 0;
                    }
                    totalMosqAct += Number(d.val10);
                    totalMeMosVal += Number(d.val4);
                 });
                totalMosqAct = totalMosqAct / list.length;
                totalMeMosVal = totalMeMosVal / list.length;

                totalMosqAct = totalMosqAct.toFixed(0);
                totalMeMosVal = totalMeMosVal.toFixed(0);
                commit('MOSQ_ACT', String(totalMosqAct));
                commit('TOTAL_ME_MOS_VAL', String(totalMeMosVal));
                commit('MEDIUM_MOSQ_LIST', list);
            });
        },

        SET_SELECTED_SUB_MENU({commit}, selectedSubMenu) {
            commit('SELECTED_SUB_MENU', selectedSubMenu);
        },

        SET_SELECTED_ME_MOSQ({commit}, selectedMeMosq) {
            commit('SELECTED_ME_MOSQ', selectedMeMosq);
        },
        
    }
}
